<template>
	<div class="user-home">
    <div class="warp">
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
    <div class="nav-bar">
      <LeftMenu></LeftMenu>
    </div>
	</div>
</template>

<script>
  import LeftMenu from '@/views/userCenter/LeftMenu.vue'
  export default {
    data() {
      return {
        test: 'abc',
      }
	  },
    computed:{

    },
    beforeRouteEnter: (to, from, next) => {
      next();
    },
    components: {
      LeftMenu
    },
    mounted(){
      const userData = this.$storage.get('__USD');
      if (!userData){
        this.$router.push({
            path: '/login'
        })
      }
    }
}

</script>



// WEBPACK FOOTER //
// src/views/userCenter/UserHome.vue